import React, { useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../../styles/Dashboard.css';
import Navbar from '../navbar';
import Sidebar from './../sidebar/admin';

const AdminDashboard = () => {
    const [admin, setAdmin] = useState(null);
    const [user, setUser] = useState(null);
    const navigate = useNavigate();
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
    };
    useEffect(() => {
        const fetchAdmin = async () => {
            try {
                const token = localStorage.getItem('token');
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/admin`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const response1 = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/auth/dashboard`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setUser(response1.data);
                setAdmin(response.data);
            } catch (error) {
                localStorage.removeItem('token');
                navigate('/login');
            }
        };
        fetchAdmin();
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <div className=''>
            <Navbar user={user} admin={admin} handleLogout={handleLogout} isSidebarOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
                closeSidebar={closeSidebar} />
            <div className="flex" >
                <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
                <div className="w-full md:p-5 bg-[#121212] border-[#353535] min-h-screen border-l">
                    <Outlet context={{ user, setUser }} />
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;